// All activities from CSforAll Hour of AI (https://csforall.org/en-US/activities/hour-of-ai)
// teacherUrl is included wherever a teacher resource/notes link is available on the source page.

export const gamesData = [
  {
    id: 1,
    title: "Mix & Move with AI",
    provider: "Code.org",
    description: "Design your own dancer, code a music remix, and choreograph a dance — all in one experience! Students explore three creative stages, using AI prompts to spark inspiration and coding concepts to customize their final project. No prior experience needed!",
    gradeRange: "K-8",
    playUrl: "https://studio.code.org/s/mix-move-ai-2025/reset",
    teacherUrl: "https://studio.code.org/s/mix-move-ai-2025/lessons/1",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5VAjHP5PYyuJ0Vmgrk2nni/de51781ca76af581a537887b50e95067/Mix_MoveCard.png",
  },
  {
    id: 2,
    title: "Minecraft Hour of AI: The First Night",
    provider: "Minecraft Education",
    description: "Survive your first night in Minecraft with an AI helper that needs your guidance! Teach it to recognize resources, craft tools, and build shelter before darkness falls. When it forgets essential details, you'll discover why AI requires human oversight.",
    gradeRange: "3-8",
    playUrl: "https://aka.ms/thefirstnightlesson",
    teacherUrl: "https://aka.ms/HOAI25EducatorGuide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5bSnSdULjNL9PFuzDy5rHK/151ae934531376ce80aae5a1444988cd/V9_MCEDU_HOAI_TheFirstNight_3840x2160_PROVISIONAL_FINAL__1_.jpeg",
  },
  {
    id: 3,
    title: "AI Quests",
    provider: "Google",
    description: "AI Quests is a gamified, in-class learning experience which allows students to step into the shoes of Google researchers using AI to solve real-world challenges.",
    gradeRange: "6-12",
    playUrl: "https://research.google/ai-quests",
    teacherUrl: "https://research.google/ai-quests/intl/en_gb/teacher-resources",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/3sQmMOFTNiHhJxlJITe5CX/00b866cc15c81fa77d18265207f16ffc/AI-Quests.jpg",
  },
  {
    id: 4,
    title: "Exploring AI with Scratch Face Sensing Blocks",
    provider: "Scratch Foundation",
    description: "Use Scratch Face Sensing blocks to control a game with a face tilt, draw with your nose, create face filters, and more! Test for false negatives or positives.",
    gradeRange: "3-8",
    playUrl: "https://scratch.mit.edu/projects/1208621527/editor?tutorial=face-sensing",
    teacherUrl: "https://www.scratchfoundation.org/learn/learning-library/face-sensing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/77CtcMzgESrGaS9CE3YWa2/d93936f77020262505c1d5d6a8dfd8ca/ScratchFaceSensing_HourofAI-notext_480w.png",
  },
  {
    id: 5,
    title: "LEGO® Education: Modeling Machine Learning",
    provider: "LEGO® Education",
    description: "This activity uses hands-on materials, imaginative play, and iterative development to demystify Artificial Intelligence and machine learning models. Students build and 'train' a model of an animal to understand how computer scientists train a computer.",
    gradeRange: "K-5",
    playUrl: "https://education.lego.com/en-us/resources/computer-science-week/",
    teacherUrl: "https://assets.education.lego.com/v3/assets/blt293eea581807678a/blt8e15ddbbc3d9a554/691200cf9ff683ade0a748f5/LE_Hour_of_AI_Submission.pdf",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/7Lxk5faiNM1vFArPeUH9JN/b5f6aaa53e3a9b0f2ad1894e854e625c/1125_Thumbnail_HourOfAI_Activity2_logo.png",
  },
  {
    id: 6,
    title: "Create Your Dream Product with Generative AI",
    provider: "Adobe",
    description: "Students brainstorm an original product idea, design its logo or ad using Adobe Express, and use generative AI to visualize how it looks and works — encouraging creativity, innovation, and ideas.",
    gradeRange: "6-12",
    playUrl: "https://new.express.adobe.com/design/template/urn:aaid:sc:VA6C2:14f97752-2381-5881-bbe9-5ad5f4c18737",
    teacherUrl: "https://new.express.adobe.com/publishedV2/urn:aaid:sc:VA6C2:75f8c38c-4002-4453-b77c-818268f9d61f",
    thumbnailUrl: "",
  },
  {
    id: 7,
    title: "MakeCode Bug Arena",
    provider: "Microsoft",
    description: "Use Microsoft MakeCode Arcade to code and train your own super-smart bug using AI algorithms and challenge other AI bugs in an epic Tower battle for ultimate Bug Arena glory!",
    gradeRange: "3-8",
    playUrl: "https://aka.ms/bug-arena",
    teacherUrl: "https://aka.ms/ba-edu",
    thumbnailUrl: "",
  },
  {
    id: 8,
    title: "VS Code for Edu Slither Slam",
    provider: "Microsoft",
    description: "Explore Artificial Intelligence and prompt engineering by competing in a fast-paced Snake game tournament using Microsoft Visual Studio Code for Education!",
    gradeRange: "6-12",
    playUrl: "https://aka.ms/slither-slam",
    teacherUrl: "https://aka.ms/slither-slam-educator",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5J9TYXFCg4ij9icZWFRyvG/fe2343d35220687f894c3601f5eef612/slitherslam.png",
  },
  {
    id: 9,
    title: "Create Your Own Roblox Obby with AI Assistant",
    provider: "Roblox",
    description: "Create your own Roblox game for free with Roblox Studio and AI Assistant! Design an obstacle course (obby) where players jump across platforms and avoid obstacles until they reach the final goal. Student login required.",
    gradeRange: "6-12",
    playUrl: "https://create.roblox.com/docs/tutorials/curriculums/building",
    teacherUrl: null,
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/QG4eIJugRCYSJR04qVMIh/3892c287058fc9c4760bf85a9f5048d7/BuildingThumbnail.png.webp",
  },
  {
    id: 10,
    title: "AI HackStack: Poetry in Motion",
    provider: "CodeCombat",
    description: "Bring poetry to life with AI HackStack! Learners analyze a poem's theme, craft prompts to generate images that illustrate its meaning, and critique the AI's outputs for bias.",
    gradeRange: "6-12",
    playUrl: "https://codecombat.com/ai/play/hour-of-ai?utm_source=hour-of-ai",
    teacherUrl: "https://drive.google.com/drive/folders/1_GA5uOuEoBzhxLMeQ_DHSmsR_Ts7g5a6",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/16CrkMltRlqYvfIYhErWWg/aeffea134799ba20d1843c8a24c99114/AI_HackStack_Poetry_in_Motion__480_x_360_.png",
  },
  {
    id: 11,
    title: "CodeCombat: AI Esports",
    provider: "CodeCombat",
    description: "AI meets esports in this coding challenge! Start by learning prompts and algorithms, then experiment with vibe coding to find winning tactics. Join forces with an AI assistant and face the CPU in an ultimate AI League battle!",
    gradeRange: "6-12",
    playUrl: "https://codecombat.com/ai/play/hour-of-ai?utm_source=hour-of-ai",
    teacherUrl: "https://drive.google.com/drive/folders/14C-Wh806lAWeVp6QJg4p1CdsfQs-9hHc?usp=drive_link",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/7xo63SAUUeGpU4UQxFoGlM/77123c1fc614c4f8aba7049f0f073b87/CodeCombat_AI_League__480_x_360_.png",
  },
  {
    id: 12,
    title: "Fruit Fighter",
    provider: "Tynker",
    description: "Recreate the addictive mobile classic Fruit Ninja. Use p5.js and AI to make this webcam-powered game.",
    gradeRange: "6-12",
    playUrl: "https://www.tynker.com/hour-of-code/fruit-fighter",
    teacherUrl: "https://www.tynker.com/hour-of-code/fruit-fighter-guide.pdf",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/1phKLOmwxSJOv9bw5Qrw7R/6acca6f5d4d13fe8b3a2050931fdcfae/Tynker_-_Fruit_Fighter_430x240.png",
  },
  {
    id: 13,
    title: "Scratch + AI: Spot the Snow Leopards",
    provider: "Coco Coders",
    description: "Discover how AI can spot animals in photos and see how scientists use it to track snow leopards in the wild. Then jump into Scratch to build your own AI project that identifies animals.",
    gradeRange: "3-8",
    playUrl: "https://www.cococoders.com/hour-of-ai-scratch",
    teacherUrl: "https://drive.google.com/file/d/1ZsODthhqA7xoodyyaC17a4eG9NrlR7HT/view?usp=sharing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2Y5TBCqXGZAUhFM1BdcexS/b3193f83b3f7e9015f2ebab5226daefa/HourofAI_Project_Scratch1.png",
  },
  {
    id: 14,
    title: "Two Truths & AI",
    provider: "Common Sense Media",
    description: "Two Truths & AI is an interactive digital literacy game that teaches students to identify AI-generated content and develop critical media literacy skills.",
    gradeRange: "6-12",
    playUrl: "https://www.commonsense.org/two-truths-and-ai",
    teacherUrl: "https://docs.google.com/document/d/1WJLZSMhiAz6Fv4bAuyD9jgoiTQt1i3YvZfzdF4Cnabw/edit?tab=t.0",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/1RdFOXlVGjhI9xuhyQZqml/a3eb866ecdd9928eafbe367275361c23/twotruthsai_image.png",
  },
  {
    id: 15,
    title: "Vibe Coding: Build Your First Game Using AI",
    provider: "Lovable x imagi",
    description: "This activity introduces students to vibe coding. Students learn what prompts are, then create and customize their own game that can be adapted to any subject.",
    gradeRange: "6-12",
    playUrl: "https://imagilabs.com/pages/hour-of-code-vibe-coding",
    teacherUrl: "https://docs.google.com/document/d/10l0KrXVbtZ8VdkXKBccnSmKDAEFf6YQW5H-rwlQSkMA/edit?usp=sharing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/6XSOKpDVSQoQrzGKZSCRD3/c57c32079568d3d752957c32b5e3da1d/cover-vibe-coding-small.png",
  },
  {
    id: 16,
    title: "AI for Good",
    provider: "Minecraft Education",
    description: "Program the Minecraft Agent to collect data about forest fires. Get a high-level understanding of how Artificial Intelligence can be used to collect data about forest fires. Learn coding basics and explore a real-world example of AI.",
    gradeRange: "3-8",
    playUrl: "https://aka.ms/minecraft-aiforgood",
    teacherUrl: "https://aka.ms/HoCEducatorGuide_en-US",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2WRl57x6rf3Zq8cyeSxD03/c7a4562f472fdfffdc196319ae545796/MCEDU_HOC_LessonPDP.png",
  },
  {
    id: 17,
    title: "AI for Oceans",
    provider: "Code.org",
    description: "Computer science is about so much more than coding! Learn about AI, machine learning, training data, and bias, while exploring ethical issues and how AI can be used to address world problems.",
    gradeRange: "3-8",
    playUrl: "https://studio.code.org/s/oceans/reset",
    teacherUrl: "https://studio.code.org/s/oceans/lessons/1",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/3HGqIPlNknJPhDp1ky4PKI/d4781f3c0554f87891e1b437dc0592dc/oceans.jpg",
  },
  {
    id: 18,
    title: "AI Future Innovators Quest",
    provider: "MagicSchool AI",
    description: "AI Future Innovators Quest is an interactive MagicSchool lesson for ages 9–12. Students learn what AI is, how it works, and ethical use through fun challenges, inventing and pitching AI ideas — all inside the platform.",
    gradeRange: "3-6",
    playUrl: "https://student.magicschool.ai/s/join?joinCode=hTnqLQ",
    teacherUrl: "https://docs.google.com/document/d/1v6kT6kc35Rd6nbzhjacQ-elLQhhzclHqIVA-es6EUjQ/edit?usp=sharing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2X7RFPSZ7oLDOQcADRUdWi/b7e5355fcceb80a830b08ca15926fa8a/Hour_of_Ai_Lesson_.png",
  },
  {
    id: 19,
    title: "AI Policy Leaders: Designing Tomorrow's AI-Ready Schools",
    provider: "Mark Cuban Foundation",
    description: "AP Government students become AI policy advisors, designing the educational AI systems they'll encounter as adults. They navigate real policy trade-offs, use an interactive dashboard to test their decisions, and create a vision statement.",
    gradeRange: "9-12",
    playUrl: "https://hourofai-education-policy-git-6344a2-harsh-hour-of-ais-projects.vercel.app/",
    teacherUrl: "https://drive.google.com/file/d/1wuLz8OJooj7WE8rDbpqj8A5eP-vevC7p/view",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2PnYhRqitnZyTqBQvKFFbf/ea7efe40a2e65315c4090241f3e0e9eb/AI-Policy-Leaders--Designing-Tomorrows-AI-Ready-Schools.jpg",
  },
  {
    id: 20,
    title: "AI Snapshots",
    provider: "aiEDU",
    description: "10 minute warmups for ELA, Math, Science, and Social Studies that demystify AI and discuss bias, privacy, and consent. Includes prompts, talk moves, quick checks, and UDL supports.",
    gradeRange: "K-12",
    playUrl: "https://www.aiedu.org/ai-snapshots",
    teacherUrl: "https://docs.google.com/document/d/1vLIxqnps07FOyZ62KoUFKCGUrR7mTvvVKBllWPF14D0/edit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/1YLAYDRZchbGhtYKDcg9RV/9150a6a560225dbbfbe5af0a7aa683bc/Elementary_AI_Explorations__How_can_we_make_AI_fair_for_everyone____aiEDU__3_.png",
  },
  {
    id: 21,
    title: "Ari and Dog Discuss Artificial Intelligence",
    provider: "Seesaw Learning",
    description: "Students will explore how AI can be used to solve problems, learn strategies for identifying reliable sources, and make informed decisions about using AI responsibly. Activities include whole group discussion, partner work, and independent practice.",
    gradeRange: "K-5",
    playUrl: "https://app.seesaw.me/library/seesaw/lesson/prompt.6e20da97-5e31-45a4-a689-9a12c0fed25a",
    teacherUrl: "https://docs.google.com/document/d/1OYBdQd2zHYqjMc8I2LQMdkxGhOCcVZt43RSXZj8uQqo/edit",
    thumbnailUrl: "",
  },
  {
    id: 22,
    title: "Crack the Tough Stuff",
    provider: "JA Worldwide",
    description: "Students step into the role of young innovators tackling real-world challenges. They begin by breaking down a complex topic, then team up with NotebookLM to turn difficult material into clear insights.",
    gradeRange: "6-12",
    playUrl: "https://lnk.jaww.org/hour-of-code-crack-the-tough-stuff-ai-activity",
    teacherUrl: "https://lnk.jaww.org/hour-of-code-crack-the-tough-stuff-ai-activity-plan",
    thumbnailUrl: "",
  },
  {
    id: 23,
    title: "Creative Coding with Python and AI",
    provider: "imagi",
    description: "In this activity students learn Python basics while making their own pixel art. An AI Debugging Buddy guides them safely, helping fix code, build confidence, and use AI responsibly.",
    gradeRange: "6-12",
    playUrl: "https://imagilabs.com/pages/hour-of-code-creative-python",
    teacherUrl: "https://docs.google.com/document/d/1f2fW9FaHuSyzLHqZE9jqNUckSaH2Sajm/edit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/794gqVMBEOyzZ2uetQLfnl/1ba627c834f7f4cfd45e70f12d60fa87/cover-creative-python-small.png",
  },
  {
    id: 24,
    title: "CyberSafe AI: Dig Deeper",
    provider: "Minecraft Education",
    description: "Guide AI to design 3D printed animals, but watch out — AI makes mistakes! Search the library for real facts, gather diverse ideas from classmates, and protect everyone's privacy. Don't just accept AI at face value — dig deeper!",
    gradeRange: "3-8",
    playUrl: "https://education.minecraft.net/en-us/lessons/cybersafe-ai-dig-deeper",
    teacherUrl: "https://education.minecraft.net/content/dam/education-edition/learning-experiences/cybersafe-ai-dig-deeper/CyberSafe%20AI%20Dig%20Deeper%20EDU%20Guide_Final.pdf",
    thumbnailUrl: "",
  },
  {
    id: 25,
    title: "Dance Party: AI Edition",
    provider: "Code.org",
    description: "Learn about artificial intelligence (AI) concepts to create your own virtual dance party showcasing today's top artists. With dozens of songs to choose from, reach every student no matter their music taste. It's time to strut your stuff!",
    gradeRange: "K-8",
    playUrl: "https://studio.code.org/courses/dance-ai-2023/units/1/lessons/1/levels/1",
    teacherUrl: "https://studio.code.org/courses/dance-ai-2023/units/1/lessons/1",
    thumbnailUrl: "",
  },
  {
    id: 26,
    title: "Elementary AI Explorations — How can we make AI fair for everyone?",
    provider: "aiEDU",
    description: "Five 15–20-min activities help students link fairness to AI data, access, labeling, and privacy. Students coauthor a public Class Fair AI Guidelines poster and imagine community-benefiting uses.",
    gradeRange: "K-5",
    playUrl: "https://www.aiedu.org/ai-explorations",
    teacherUrl: "https://docs.google.com/document/d/1vLIxqnps07FOyZ62KoUFKCGUrR7mTvvVKBllWPF14D0/edit?tab=t.uadk98gk5c6z",
    thumbnailUrl: "",
  },
  {
    id: 27,
    title: "Elementary AI Explorations — What is AI?",
    provider: "aiEDU",
    description: "Five 15–20-min unplugged explorations — AI or Not?, Pattern Predictors, Handshake Programmer — help students define AI as systems that learn from data. Simple materials, no logins, UDL supports.",
    gradeRange: "K-5",
    playUrl: "https://www.aiedu.org/ai-explorations",
    teacherUrl: "https://docs.google.com/document/d/1vLIxqnps07FOyZ62KoUFKCGUrR7mTvvVKBllWPF14D0/edit?tab=t.5rfis8acxfeb",
    thumbnailUrl: "",
  },
  {
    id: 28,
    title: "Fantastic Fairgrounds",
    provider: "Minecraft Education",
    description: "Discover how to unlock the power of AI through the wondrous pavilions of Fantastic Fairgrounds. Take on the role of a problem-solver, working alongside an AI assistant to solve challenges in the Bee, Light Show, and Art Pavilions.",
    gradeRange: "3-8",
    playUrl: "https://aka.ms/FantasticFairgrounds",
    teacherUrl: "https://education.minecraft.net/content/dam/education-edition/learning-experiences/fantastic-fairgrounds/Fantastic%20Fairgrounds_EDU%20Guide.pdf",
    thumbnailUrl: "",
  },
  {
    id: 29,
    title: "Fresh & Forecasted: Lemonade by the Data",
    provider: "JA Worldwide",
    description: "Students pretend to own a lemonade stand. Weather affects demand. Using a classroom AI chatbot and geography-specific data, they build a simple financial model to earn a small profit, developing an entrepreneurial mindset with AI.",
    gradeRange: "6-12",
    playUrl: "https://lnk.jaww.org/hour-of-code-lemonade-ai-activity",
    teacherUrl: "https://lnk.jaww.org/hour-of-code-lemonade-ai-activity-plan",
    thumbnailUrl: "",
  },
  {
    id: 30,
    title: "Generation AI",
    provider: "Minecraft Education",
    description: "Use problem solving, creativity, and computational thinking with the principles of Responsible AI. With coding in blocks or Python, Hour of AI allows anyone to learn the basics of coding and how to build a better AI for all.",
    gradeRange: "3-8",
    playUrl: "https://aka.ms/HourofCode2023",
    teacherUrl: "https://aka.ms/hoc23eduguide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5SuBAE9JXePWZAWGpLIfJ4/d39591e8115641e313c67ccb3993690d/generation_ai.jpg",
  },
  {
    id: 31,
    title: "Music Lab: Jam Session",
    provider: "Code.org",
    description: "Make music and learn to code with Music Lab: Jam Session! In this self-guided, one-hour activity, students remix tracks from artists like Lady Gaga and Shakira while coding basics such as sequencing, and exploring AI-driven beat creation.",
    gradeRange: "3-8",
    playUrl: "https://studio.code.org/s/music-jam-2024/reset",
    teacherUrl: "https://studio.code.org/s/music-jam-2024/lessons/1",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/4gJcj1Ns6tctlsNgViToqP/5a222ae860d70044d4e03629bc8b47ed/music_lab_jam.jpg",
  },
  {
    id: 32,
    title: "Reed Smart: AI Detective",
    provider: "Minecraft Education",
    description: "Join Detective Reed Smart to investigate curious cases of AI misuse! Analyze deepfakes, spot AI-generated content, and learn how AI works as you follow clues and analyze evidence across three cases.",
    gradeRange: "3-8",
    playUrl: "https://aka.ms/reedsmart",
    teacherUrl: "https://aka.ms/reedsmartguide",
    thumbnailUrl: "",
  },
  {
    id: 33,
    title: "What is AI? For Early Childhood Students",
    provider: "Day of AI",
    description: "This activity introduces children (ages 5–7) to Artificial Intelligence in a developmentally appropriate manner! Students explore the difference between artificial and natural items and learn how machines act 'smart' by using sensors and more!",
    gradeRange: "K-2",
    playUrl: "https://drive.google.com/drive/folders/1H5kg6u8lKXFyXEJCrysqiCmaYSg-B1xi?usp=drive_link",
    teacherUrl: "https://docs.google.com/document/d/1NOBeYbf4mSSHELNHmJiBp487Gc5JXd7xGaSbb8pCNeo/edit?usp=sharing",
    thumbnailUrl: "",
  },
  {
    id: 34,
    title: "ActiveAI: Interactive K12 AI Literacy Modules",
    provider: "ActiveAI X Junyi Academy",
    description: "ActiveAI is an interactive tutoring system that builds AI literacy for K-12 students. Through bite-size modules aligned with the AILitFramework, students explore, construct, and assess AI systems while receiving immediate, personalized AI feedback.",
    gradeRange: "K-12",
    playUrl: "https://app.active-ai.io/hour_of_ai",
    teacherUrl: "https://docs.google.com/document/d/1WOF1-zjoRZpTd0BMkMuLJ2WlJQUacH7h0tE1jrIFJDU/edit?tab=t.0",
    thumbnailUrl: "",
  },
  {
    id: 35,
    title: "AI Assistants to the Rescue: Explain My Program",
    provider: "Sphero",
    description: "Ever wondered how to talk to a robot? In this lesson, you'll meet Sphero's AI Assistant that can explain your code step-by-step.",
    gradeRange: "6-12",
    playUrl: "https://edu.sphero.com/cwists/preview/96237",
    teacherUrl: "https://docs.google.com/document/d/1W_WsKI6VU7tSwjwpNH88YOMDA4ILoMJi17X-vHMGzJY/preview",
    thumbnailUrl: "",
  },
  {
    id: 36,
    title: "AI HackStack: Social Media Showdown",
    provider: "CodeCombat",
    description: "Play social media manager in this fun algebra + AI challenge! Prompt AI to build formulas, model post engagement rates, and judge head-to-head celebrity content battles. Master the art of online influence with critical math and AI literacy skills.",
    gradeRange: "6-12",
    playUrl: "https://codecombat.com/ai/play/hour-of-ai?utm_source=hour-of-ai",
    teacherUrl: "https://drive.google.com/drive/folders/14oExnuXMqOr9viXMZ8L5_v_byrxYTTJe?usp=drive_link",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/6n7RjfBUqViRvalPqvNuhZ/f896190073d681315ce4d4306ab9f5b4/AI_HackStack_Social_Media_Showdown___430_x_240_.png",
  },
  {
    id: 37,
    title: "AI HackStack: Vibe Coding Lab",
    provider: "CodeCombat",
    description: "Dive into vibe coding with AI HackStack! Guide a hero with simple algorithms, explore syntax, and then prompt AI to remix code into games and websites. Experiment, play, and see how coding can feel creative, fast, and fun.",
    gradeRange: "6-12",
    playUrl: "https://codecombat.com/ai/play/hour-of-ai?utm_source=hour-of-ai",
    teacherUrl: "https://drive.google.com/drive/folders/141RVAJpEgievxSE_-6wgU7eQcwxhJCma?usp=drive_link",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/1wRXGbovSXI9KcczeBPeH1/6f37d4f459a5ac653a013187e5423f03/AI_HackStack_Vibe_Coding_Lab__480_x_360_.png",
  },
  {
    id: 38,
    title: "AI is a Hoot",
    provider: "CodeMonkey Studios",
    description: "Train an AI to recognize your poses! In this block-based coding activity, students use Teachable Machine, incorporated directly into the course, then program an owl to respond by jumping, shrinking, and more based on real-time movements.",
    gradeRange: "3-8",
    playUrl: "https://app.codemonkey.com/courses/ai-mini-course#1",
    teacherUrl: "https://drive.google.com/file/d/1O1ovIg8whihuA5WIh5JEURmggSEPAYVA/view?usp=sharing",
    thumbnailUrl: "",
  },
  {
    id: 39,
    title: "AI Square X My Semiconductor Adventure",
    provider: "Junyi Academy Foundation",
    description: "Join AI Square on a journey into semiconductors, engaging with AI and creating with AI to see how chips shape our daily lives.",
    gradeRange: "6-12",
    playUrl: "https://link.junyiacademy.org/86xsr4",
    teacherUrl: null,
    thumbnailUrl: "",
  },
  {
    id: 40,
    title: "AI with RVR+: Autonomous Vehicles",
    provider: "Sphero",
    description: "It's impossible to have a conversation about how AI will impact our lives without discussing autonomous vehicles. In this lesson, program RVR+ to drive on its own and explore how humans and machines can work together to safely automate driving.",
    gradeRange: "6-12",
    playUrl: "https://edu.sphero.com/cwists/preview/74228",
    teacherUrl: "https://docs.google.com/document/d/1ImO7MXXFM-nur5MvIuWaw6SvV7seph0Fw4ELNBBVPD0/preview",
    thumbnailUrl: "",
  },
  {
    id: 41,
    title: "Autonomous indi",
    provider: "Sphero",
    description: "Students are exposed to the idea of training models in the context of autonomous driving by 'training' their indi robot to navigate a set path.",
    gradeRange: "3-8",
    playUrl: "https://edu.sphero.com/lessons/autonomous-indi",
    teacherUrl: "https://docs.google.com/document/d/1DFNd4EacerdrEMXhz9NdjR84E4FUAcMjTjh8uNq4wgU/preview",
    thumbnailUrl: "",
  },
  {
    id: 42,
    title: "Balancing Act",
    provider: "Tynker",
    description: "A beginner activity where students design a webcam-controlled game using physics-engine blocks, AI pose detection, and loops. The challenge involves balancing a ball on a moving platform using head movements.",
    gradeRange: "6-12",
    playUrl: "https://www.tynker.com/hour-of-code/balancing-act",
    teacherUrl: "https://www.tynker.com/hour-of-code/balancing-act-guide.pdf",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/4WmnZ4NsTNUEL3Lg3UcsYl/6ce6248bb29e309399c11929cee9c410/Tynker_-_Balancing_Act_430x240.png",
  },
  {
    id: 43,
    title: "BOLT+ Meets ChatGPT in 2025",
    provider: "Sphero",
    description: "Artificial intelligence-powered chatbots, like ChatGPT, are improving rapidly, and so is Sphero. In this lesson, students test ChatGPT's ability to program Sphero's latest round robot, BOLT+.",
    gradeRange: "6-12",
    playUrl: "https://edu.sphero.com/cwists/preview/95903",
    teacherUrl: "https://docs.google.com/document/d/19k1oVIvTWlASVbrBGdiTi2O5msAf-ZQTXmixNUnf2LQ/preview",
    thumbnailUrl: "",
  },
  {
    id: 44,
    title: "Build a Multiplayer Puzzle Game with AI",
    provider: "Rosebud AI",
    description: "Make a game just by describing it. In this one-hour lesson, create an immersive world with hidden puzzles and funny characters from scratch step by step. The final game can be shared with and played by multiple people at the same time.",
    gradeRange: "6-12",
    playUrl: "https://lab.rosebud.ai/hour-of-ai",
    teacherUrl: null,
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/29h9IDZBlaawSdKUCo83h8/6df40ee7436b4d7c67f81ca89a1c488b/Hour_of_AI_Thumbnail.png",
  },
  {
    id: 45,
    title: "Code your Pac-Man Game",
    provider: "FHNW (Switzerland)",
    description: "Students design and code their own Pac-Man game using the visual coding platform Ruler.game. They build their own level, program Pac-Man and ghosts, and explore how simple AI rules work through play and experimentation.",
    gradeRange: "6-12",
    playUrl: "https://ruler.game/?tutorial=Pac-Man_Hour-of-AI-US",
    teacherUrl: "https://sites.google.com/view/ruler-ai/teacher-material/",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/3a7N32u1IOch73dbaLokNI/8d2d3c17df7ca1a7e5eb937a4688d2a3/Cover_Hour_of_AI_PacMan.jpg",
  },
  {
    id: 46,
    title: "Drone Command — Operation Uplink",
    provider: "NSWC Carderock",
    description: "Students build a playable ocean-rescue game in MakeCode Arcade, then code a simple AI advisor using rule-based heuristics. Along the way they learn events, conditionals, abstraction, and human-AI decision-making.",
    gradeRange: "6-12",
    playUrl: "https://sjwines.github.io/",
    teacherUrl: "https://docs.google.com/presentation/d/1to-6WSOphuHXHLd1mu41ui177xo0vCCvbcJFIn6Wbzg/edit?usp=sharing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2HVnrP5s4nSTTaYg8uJkhO/75e73b7b83873c7bac07999f067ffc6e/Drone_Command_Operation_Uplink_Title_Screen.png",
  },
  {
    id: 47,
    title: "Large Language Models: Math, not Magic",
    provider: "Hello World CS",
    description: "Students explore how large language models (LLMs) generate text one token at a time and represent meaning mathematically. They apply this knowledge by creating an artifact that refutes common misconceptions about how LLMs work.",
    gradeRange: "9-12",
    playUrl: "https://helloworldcs.org/hour-of-ai",
    teacherUrl: "https://drive.google.com/file/d/1JsgCDJBivXLyPXbSKpi90t3feys2OpuA/view?usp=sharing",
    thumbnailUrl: "",
  },
  {
    id: 48,
    title: "Machine Learning and Music Classification",
    provider: "CodeHS",
    description: "Students train an AI model with Teachable Machine to classify songs by musical genre. They collect data, test their models, add more training data, and reflect on how dataset size and variety impact model accuracy and fairness.",
    gradeRange: "6-12",
    playUrl: "http://codehs.com/hourofai/music",
    teacherUrl: "http://codehs.com/hourofai/music/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/7uyPtequl2CxLZyzlcQtGD/c1d1312fc83ec42d0de4d085fd5b17f1/Machine_Learning_and_Music_Classification_480x360.png",
  },
  {
    id: 49,
    title: "MegaMinds: Exploring AI Ethics",
    provider: "MegaMinds",
    description: "Students dig into AI ethics and the ways AI can help or harm. They interact with AI characters, uncover bias and misinformation in case studies, and conclude by creating their own Personal AI Ethics Statement.",
    gradeRange: "6-12",
    playUrl: "https://dash.megaminds.world/explore/130/ai-literacy-ethics",
    teacherUrl: "https://docs.google.com/document/d/1tjnw8BPQUxFm8UM95TfZYoASb8V7VUSPb9Rs1K_GZ9M/edit?usp=sharing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5zPzTouqW3aoAfo42dHYlB/7537567573b5062ace4ad49a2b6db5be/megamindsAILiteracyBundle.jpg",
  },
  {
    id: 50,
    title: "micro:bit CreateAI Taster Lessons",
    provider: "Micro:bit Educational Foundation",
    description: "Two lessons introducing the concepts of AI and machine learning using physical computing with micro:bit CreateAI.",
    gradeRange: "6-12",
    playUrl: "https://microbit.org/teach/lessons/createai-taster-lessons/",
    teacherUrl: "https://microbit.org/teach/lessons/createai-taster-lessons/",
    thumbnailUrl: "",
  },
  {
    id: 51,
    title: "Pitch Perfect: AI Pitch Predictor",
    provider: "Sphero",
    description: "Softball and baseball pitchers throw different types of pitches to make it harder to hit the ball. Batters have to detect the speed of pitches like fastballs and changeups. Can a robot detect the difference in these pitches?",
    gradeRange: "6-12",
    playUrl: "https://edu.sphero.com/cwists/preview/96238",
    teacherUrl: "https://docs.google.com/document/d/1jMhsxiiK5c5CzOUBoW1PFimxikfKDpbLRtgaxIPm3f0/view",
    thumbnailUrl: "",
  },
  {
    id: 52,
    title: "RoboGarden AI Labs",
    provider: "RoboGarden",
    description: "Students code a drone to collect data while exploring continents, then enter the AI Lab to transform that data into creative outputs. They learn coding, AI prompting, parameter tuning, and pipeline control through fun, geography-based challenges.",
    gradeRange: "3-8",
    playUrl: "https://playground.robogarden.ca/hourofAI/steam/all",
    teacherUrl: null,
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/4mKyPrVwP6jBha9hXmmAlM/b8312a27212ec5c6a894a8527b8a9181/RG_AI_Lab_Cover.png",
  },
  {
    id: 53,
    title: "SceneCraft",
    provider: "EngageAI Institute",
    description: "Get hands-on with SceneCraft — a cutting-edge, AI-powered storytelling tool developed by the NSF-funded EngageAI Institute. SceneCraft turns teacher prompts into immersive narratives designed to captivate students and fuel learning.",
    gradeRange: "6-12",
    playUrl: "https://www.scenecraft.org/",
    teacherUrl: "https://docs.google.com/document/d/1aNq3MY9-aBPZYVEDkaTAxJjx-FhtxnTStvQFKlid4lE/edit?tab=t.0",
    thumbnailUrl: "",
  },
  {
    id: 54,
    title: "The Magic Inside GPT-2",
    provider: "Myai101",
    description: "An interactive visualization that reveals the inner workings of how GPT-2 processes language. Explore each layer — from tokenization and attention to prediction — and see how AI models read, reason, and generate text one token at a time.",
    gradeRange: "9-12",
    playUrl: "https://myai101.com/hourofai/gpt2",
    teacherUrl: null,
    thumbnailUrl: "",
  },
  {
    id: 55,
    title: "The Spiral: AI Safety Investigation",
    provider: "Being Human With AI",
    description: "This activity challenges students to investigate cases of AI psychological manipulation using a hybrid approach, including discussion and an interactive game.",
    gradeRange: "9-12",
    playUrl: "https://beinghumanwithai.org/thespiral",
    teacherUrl: "https://beinghumanwithai.org/teacher-resources-the-spiral",
    thumbnailUrl: "",
  },
  {
    id: 56,
    title: "Tickle Monster",
    provider: "Tynker",
    description: "Use Tynker's AI blocks to make a virtual monster come alive! Create a character that responds to hand movements.",
    gradeRange: "K-5",
    playUrl: "https://www.tynker.com/hour-of-code/tickle-monster",
    teacherUrl: "https://www.tynker.com/hour-of-code/tickle-monster-guide.pdf",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/4aQh6d2lMz1uDql3HhKeMY/fb8d642dff7b7c64d835eed8ae92f5c6/Tynker_-_Tickle_Monster_480x360.png",
  },
  {
    id: 57,
    title: "Time Travelers: Exploring AI Ethics Across Eras",
    provider: "Brisk Teaching",
    description: "Step into a time-traveling podcast and character chat where students meet AI thinkers from past and future — like Ada Lovelace and Sam Altman — to debate how innovation meets responsibility and explore timeless questions of AI ethics.",
    gradeRange: "6-12",
    playUrl: "https://app.briskteaching.com/copy/3vcajs",
    teacherUrl: "https://drive.google.com/file/d/1K9DkIIPwjF3QX_068KQY3CTZbxhU0vpY/view?usp=sharing",
    thumbnailUrl: "",
  },
  {
    id: 58,
    title: "Translation Station",
    provider: "Digital Moment",
    description: "Type any word, choose a language, click and — boom, instant translation with audio. Then become language detectives: test wild phrases, explore new languages with multilingual classmates, and uncover where AI nails it or fails!",
    gradeRange: "K-8",
    playUrl: "https://resources.digitalmoment.org/hour-of-ai-2025-wip/",
    teacherUrl: null,
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/1OEqkQKY1stK2JginbxBkp/9363f5669bf5b0580aef53f6590bd0bf/black_480.png",
  },
  {
    id: 59,
    title: "Vibe Coding in the CS Classroom",
    provider: "bool",
    description: "Teachers learn about vibe coding and explore best practices for meaningful use of AI as a tool in the computer science classroom. Teachers will need to create a free Bool account to access this activity.",
    gradeRange: "Educator",
    playUrl: "http://bool.com/hourofai/teaching",
    teacherUrl: "http://codehs.com/bool/hourofai_teaching/guide",
    thumbnailUrl: "",
  },
  {
    id: 60,
    title: "Vibe Coding with AI",
    provider: "bool",
    description: "Individuals explore how to build programs with natural language prompts, refine and debug AI outputs, and design an app.",
    gradeRange: "6-12",
    playUrl: "http://bool.com/hourofai/vibecoding",
    teacherUrl: "http://codehs.com/bool/hourofai/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5OMU12JQt2jouHntOTA1dq/86d2fc5e4b4a2a4e3e2facf866cbd8c7/Vibe_Coding_with_Artificial_Intelligence_430x240.png",
  },
  {
    id: 61,
    title: "Weather Control",
    provider: "Tynker",
    description: "Weather Control is a beginner activity where students use Tynker's AI body tracking model to create a fun, interactive project where they can control the weather using gestures!",
    gradeRange: "K-5",
    playUrl: "https://www.tynker.com/hour-of-code/weather-control",
    teacherUrl: "https://www.tynker.com/hour-of-code/weather-control-guide.pdf",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2QvnuDqWAQ2vZlVLgTC3up/15f50fde60d345eb5b8f20a4da91246d/Tynker_-_Weather_Control_480x360.png",
  },
  {
    id: 62,
    title: "A Hero Story: Creating an AI-illustrated Storybook",
    provider: "Binary Logic",
    description: "Students create their own heroes and tell short stories in comic form. Working in teams, they invent characters, refine text with AI, and produce three illustrated panels.",
    gradeRange: "6-8",
    playUrl: "https://binarylogic.net/hourofai-activity-for-middle-school-students/",
    teacherUrl: "https://drive.google.com/file/d/1JesaE4ZGpYtVg5vUO9h2xnJPMJJDMi_9/view",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/7AXhtqv9vRXaRMu2Zrx48y/639bf0f8a059947a4279da44e7b4a4c1/BL_HofAI_MS.jpg",
  },
  {
    id: 63,
    title: "AI & SDGs: Innovation with Responsibility",
    provider: "Binary Logic",
    description: "Students explore how Artificial Intelligence can help or hinder the UN Sustainable Development Goals (SDGs). In groups, they choose a goal, design an AI-powered concept poster, share their work, and discuss trade-offs.",
    gradeRange: "9-12",
    playUrl: "https://binarylogic.net/hourofai-activity-for-high-school-students/",
    teacherUrl: "https://drive.google.com/file/d/13ivmsqsTLxTrMFY0peUkAa_hb2bNOAaQ/view",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/1inuaVYnj6s1ih0fNymFFh/92a05466072b7aaeadea4bbd70249b16/BL_HofAI_HS.jpg",
  },
  {
    id: 64,
    title: "AI Basics: From Predictions to Creations",
    provider: "CodeHS",
    description: "Explore generative vs predictive AI through an interactive Google Experiment, then build and test your own Teachable Machine model. Reflect on accuracy, bias, and AI's role in society while developing practical AI literacy skills.",
    gradeRange: "6-12",
    playUrl: "http://codehs.com/hourofai/predictions",
    teacherUrl: "http://codehs.com/hourofai/predictions/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/6YChaG88NpOFL5Lu2nzSPu/da849d13a849bedd87a299c63e6cc4f8/AI_Basics_-_From_Predictions_to_Creations_430x240.png",
  },
  {
    id: 65,
    title: "AI Problem Solvers Challenge",
    provider: "SchoolAI",
    description: "The AI Problem Solvers Challenge empowers learners to design SchoolAI Spaces that address real-world problems. Through guided prompting, they build AI literacy, practice ethical use, and showcase creativity in solving challenges.",
    gradeRange: "6-12",
    playUrl: "https://schoolai.com/hour-of-ai",
    teacherUrl: "https://drive.google.com/file/d/1190ip1-W3PpkzlRoLlGmHAraogdM1R4c/view?usp=drive_link",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5S9lpijhiZgn8RKIFw7ro3/6d6065bfd61b6ab285538a6fc491f39b/Hour_of_AI_x_SchoolAI_Cover_Image.jpg",
  },
  {
    id: 66,
    title: "AI Smart by Zigazoo — Learning AI, the smart way",
    provider: "Zigazoo",
    description: "AI Smart brings MIT's research-based lessons to life through fun, short-form videos for students. We help kids become AI literate, AI safe, and AI ready for the future. Content adapted from the Day of AI Curriculum 2025 by MIT RAISE.",
    gradeRange: "K-5",
    playUrl: "https://app.zigazoo.com/prompt/6914fcbd367ebc6a66bfbde1",
    teacherUrl: "https://docs.google.com/document/d/148Hrn6UGOHZuFOCYjvhDh_TTtQ4XmcCRVWF1yREqAYo/edit?usp=sharing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2XL3ojShPvmhaSidkgOXAQ/a2b7691724827db5903c1ee9cd9e12a4/Zigazoo_Activity_Cover_Photo.png",
  },
  {
    id: 67,
    title: "AI-Powered Population Maps",
    provider: "Ozobot",
    description: "Use the LLM block to collect real-world population and land area data from 10 different countries! Students will calculate population density, rank countries from most to least crowded, and create an AI-powered population map.",
    gradeRange: "6-12",
    playUrl: "https://classroom.ozobot.com/lessons/lnnOAZuQokTqqZrvm2g4yHRwcx",
    teacherUrl: "https://classroom.ozobot.com/lessons/lnnOAZuQokTqqZrvm2g4yHRwcx",
    thumbnailUrl: "",
  },
  {
    id: 68,
    title: "Animal Identification with AI",
    provider: "The Tech Interactive",
    description: "Use AI to help conservationists monitor and save endangered species populations! Explore how machine learning programs are trained to identify giraffes and track changes in their population.",
    gradeRange: "6-10",
    playUrl: "https://www.thetech.org/education/education-resources/lessons/animal-identification-with-ai/",
    teacherUrl: "https://www.thetech.org/education/education-resources/lessons/animal-identification-with-ai/",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/4J1PxeDL2W8bY3UPJPiIty/b513e531af1b7841c32b52e81d9601f8/animal-identification-with-ai-cover-image.png",
  },
  {
    id: 69,
    title: "Artificial Neuron",
    provider: "Ellipsis Education",
    description: "This lesson explains artificial neurons, the building blocks of AI. Using a 'beach decision' model, it shows how inputs, weights, and bias affect decisions. Students design their own neurons for various scenarios.",
    gradeRange: "6-12",
    playUrl: "https://ellipsisedu.com/en/hourofai-artificialneuron",
    teacherUrl: "https://docs.google.com/document/d/1UWYH84tH4foitHTKGLn0Ip-xyxubL-l4EvKcDHmUc3A/edit?tab=t.0",
    thumbnailUrl: "",
  },
  {
    id: 70,
    title: "Bean Learns About Artificial Intelligence",
    provider: "Seesaw Learning",
    description: "Students will learn how to be digital leaders when using Artificial Intelligence tools. Activities include whole group discussion, partner work, and independent practice.",
    gradeRange: "K-2",
    playUrl: "https://app.seesaw.me/library/seesaw/lesson/prompt.c6bf8585-ca0d-4c7f-b9fe-90fc3a99b63f",
    teacherUrl: "https://docs.google.com/document/d/1OYBdQd2zHYqjMc8I2LQMdkxGhOCcVZt43RSXZj8uQqo/edit",
    thumbnailUrl: "",
  },
  {
    id: 71,
    title: "BrainPOP's AI Dilemma: Helper, Hinderer, or Hero?",
    provider: "BrainPOP",
    description: "Students will analyze examples of AI in daily life and categorize them as a Helper (beneficial), Hinderer (problematic), or Hero (life-changing) to critically evaluate their societal role.",
    gradeRange: "3-8",
    playUrl: "https://www.brainpop.com/discover/post/hour-of-ai",
    teacherUrl: "https://6900bf2c-71ea-4894-85d7-741b98aa926c.usrfiles.com/ugd/6900bf_517f414029584805b5591b99038a3740.pdf",
    thumbnailUrl: "",
  },
  {
    id: 72,
    title: "Build Your First AI App with Scratch-Style Blocks",
    provider: "CreatiCode",
    description: "CreatiCode enhances Scratch with easy-to-use AI tools/blocks while keeping it simple to create and share. Students will learn to use AI tools like coding assistant and image generator, and create AI-driven projects.",
    gradeRange: "3-8",
    playUrl: "https://play.creaticode.com/",
    teacherUrl: null,
    thumbnailUrl: "",
  },
  {
    id: 73,
    title: "Communicating with AI",
    provider: "CodeHS",
    description: "Students explore how AI models interpret different communication systems. They test pre-trained models for letters and sign language, then design their own symbolic language and train an AI with Teachable Machine to recognize and respond to it.",
    gradeRange: "6-12",
    playUrl: "http://codehs.com/hourofai/communicating",
    teacherUrl: "http://codehs.com/hourofai/communicating/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2D7S8PCxAssqxUbmPAn1Bd/5fc44ac903a1724c7dd19541b8b55170/Communicating_with_AI_480x360.png",
  },
  {
    id: 74,
    title: "Cyrus and Dog Discuss Artificial Intelligence",
    provider: "Seesaw Learning",
    description: "Students will explore real-world situations where they might use Artificial Intelligence and practice making smart, responsible choices when using these tools. Includes whole group discussion, partner work, and independent practice.",
    gradeRange: "K-5",
    playUrl: "https://app.seesaw.me/library/my_library/lesson/prompt.1471771d-18e3-4a53-9934-23958b3ae961",
    teacherUrl: "https://docs.google.com/document/d/1OYBdQd2zHYqjMc8I2LQMdkxGhOCcVZt43RSXZj8uQqo/edit",
    thumbnailUrl: "",
  },
  {
    id: 75,
    title: "Digital Zoologists: Researching with the LLM Block",
    provider: "Ozobot",
    description: "Become a digital zoologist by using the LLM block to research animals and create a field report! Test what the LLM can accurately answer by asking a variety of questions with different output types.",
    gradeRange: "6-10",
    playUrl: "https://classroom.ozobot.com/lessons/lnvDQg3g83SxuGMiQ75717nQ3z",
    teacherUrl: "https://classroom.ozobot.com/lessons/lnvDQg3g83SxuGMiQ75717nQ3z",
    thumbnailUrl: "",
  },
  {
    id: 76,
    title: "Elective Algorithm Design",
    provider: "Ozobot",
    description: "Students compare their own class scheduling decisions to those made by AI to identify possible bias in an AI algorithm. Then, they design ethical decision trees and use Ozobot Color Codes to model fair and equitable outcomes.",
    gradeRange: "6-12",
    playUrl: "https://classroom.ozobot.com/lessons/lnXyvbChZ9QiyO7Il3l1v21Qdp",
    teacherUrl: "https://classroom.ozobot.com/lessons/lnXyvbChZ9QiyO7Il3l1v21Qdp",
    thumbnailUrl: "",
  },
  {
    id: 77,
    title: "Engaging With AI (3-5)",
    provider: "Seesaw Learning",
    description: "Students will explore how we engage with AI when it provides content and recommendations. Through a comic, interactive activities, and reflection, students recognize when AI is being used, and evaluate its accuracy.",
    gradeRange: "3-5",
    playUrl: "https://app.seesaw.me/library/my_library/lesson/prompt.28bde1f2-3ea7-464a-83c1-ac7c4b28aa0d",
    teacherUrl: "https://docs.google.com/document/d/1OYBdQd2zHYqjMc8I2LQMdkxGhOCcVZt43RSXZj8uQqo/edit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/7fTLp5U52jP8U5J8w0rE3i/b5e4d3e521d236937d554844ddbf789b/Engaging_With_AI_3-5.png",
  },
  {
    id: 78,
    title: "Engaging With AI (K-2)",
    provider: "Seesaw Learning",
    description: "Students will explore how we engage with AI when it provides content and recommendations. Through a comic, interactive activities, and reflection, students recognize when AI is being used, and evaluate its accuracy.",
    gradeRange: "K-2",
    playUrl: "https://app.seesaw.me/#/login/",
    teacherUrl: "https://docs.google.com/document/d/1OYBdQd2zHYqjMc8I2LQMdkxGhOCcVZt43RSXZj8uQqo/edit",
    thumbnailUrl: "",
  },
  {
    id: 79,
    title: "Face Detection and Face Filters",
    provider: "AI for Georgia",
    description: "Ever wonder how face filters work? In this activity, you will learn the AI algorithm that powered the fun face filters we see on social media. Then you will use face detection technology to create face filters of your own!",
    gradeRange: "6-12",
    playUrl: "https://ai4ga.org/how-computers-see-faces/",
    teacherUrl: "https://docs.google.com/document/d/1-s1eeLS5JoxlQvbTCPSZYEplg4jbwICL-kuyCLx59AU/edit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/4myJf86doNSgAEMsVX8Ncs/47c421faa7c2831794a756902cef8915/FaceFilters.jpg",
  },
  {
    id: 80,
    title: "From Prompt to Product: Mastering AI Prompt Engineering",
    provider: "CodeHS",
    description: "Explore ChatGPT and Gemini, practice prompt engineering, and reflect on AI's impact. This activity combines hands-on exploration, skill-building, and ethical reflection to build AI literacy.",
    gradeRange: "6-12",
    playUrl: "http://codehs.com/hourofai/prompteng",
    teacherUrl: "http://codehs.com/hourofai/prompteng/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/3H9qNuZSeFR7t5fkOjlBcI/97eb188ed0acce714b4509ccd45a34ee/From_Prompt_to_Product_-_Mastering_AI_Prompt-Engineering_430x240.png",
  },
  {
    id: 81,
    title: "Hands-On Machine Learning Activity with micro:bit",
    provider: "Forward Education",
    description: "Students use a micro:bit and CreateAI to train a waving-action machine learning model, explore how biased data shapes AI behavior, and discuss our responsibilities as both creators and consumers of AI.",
    gradeRange: "6-10",
    playUrl: "https://forwardedu.com/blogs/blog/hour-of-ai-lesson-plan-hands-on-machine-learning-activity-with-micro-bit",
    teacherUrl: "https://forwardedu.com/blogs/blog/hour-of-ai-lesson-plan-hands-on-machine-learning-activity-with-micro-bit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/7HtTEBrlf6g75osrrLKzpL/889cb06e576f64736166d10bb914fdbf/Hour_of_AI_Tile_480_x_360.png",
  },
  {
    id: 82,
    title: "How Are AI Models Trained?",
    provider: "CodeHS",
    description: "Students explore how AI models learn from data through interactive activities and guided reflection. They experiment with training sets, test model accuracy, and discover how data quality and quantity affect the outcomes of AI predictions.",
    gradeRange: "6-12",
    playUrl: "http://codehs.com/hourofai/howaremodels",
    teacherUrl: "http://codehs.com/hourofai/howaremodels/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/1skNa5VDlWs4mAMHefAN1U/1148e38583ecaeaf33aac20abc6c0c89/How_are_Models_Trained_480x360.png",
  },
  {
    id: 83,
    title: "How to Think Like a Neuron",
    provider: "AI for Georgia",
    description: "Students will learn about neural networks which power many of the current technologies we use today. Complete mathematical puzzle games based on a singular neuron until the neuron fires correctly.",
    gradeRange: "6-12",
    playUrl: "https://ai4ga.org/think-like-a-neuron/",
    teacherUrl: "https://docs.google.com/presentation/d/1lOXaHSEu17LuVUCDpq4MoKscVmvNiCtYzucVh5mqC3g/edit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/0Z4sEuRITMeY9J4f0fs7F/96356bab148085f81b03485af7ce9a30/ThinkLikeANeuron.png",
  },
  {
    id: 84,
    title: "Introduction to AI-Assisted Coding",
    provider: "CodeHS",
    description: "Students use AI chatbots to help design and code a Connections-style word game. They learn prompting strategies, debug and refine code with AI, and extend their game through creative challenges.",
    gradeRange: "6-12",
    playUrl: "http://codehs.com/hourofai/assistedcoding",
    teacherUrl: "http://codehs.com/hourofai/assistedcoding/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/1J3K9EV45H83KvLm6iDCyg/5e6a9d4e74ffc9e94d0330e088ede8c6/Introduction_to_AI-Assisted_Coding_480x360__1_.png",
  },
  {
    id: 85,
    title: "Invisible Inputs: Analyzing Bias in AI Healthcare Tools",
    provider: "Ozobot",
    description: "Students investigate how biased proxy data led a healthcare algorithm to underestimate the needs of certain patient groups. They analyze the case, debate fairness, and use Color Codes to model how design choices affect equity in AI.",
    gradeRange: "6-12",
    playUrl: "https://classroom.ozobot.com/lessons/lnBtMZieKvRgaC3hC328zSaA1l",
    teacherUrl: "https://classroom.ozobot.com/lessons/lnBtMZieKvRgaC3hC328zSaA1l",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/3lUnT2TnHbw6Gk8zaTJiC3/d2818961e81e77d2a7edb0921b8dabe1/InvisibleInputs.png",
  },
  {
    id: 86,
    title: "JavaScript + AI: Classifying Art",
    provider: "Coco Coders",
    description: "Explore how AI can be used to spot forgeries in the art world through the use of image classification and machine learning. Then jump into coding with JavaScript to build an AI project that identifies drawings.",
    gradeRange: "9-12",
    playUrl: "https://www.cococoders.com/hour-of-ai-javascript",
    teacherUrl: "https://drive.google.com/file/d/1R0t75OAL4D3K8kV0tIoWVbXkc_UpUThn/view?usp=drive_link",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/3b6wEoBRLDdHtgKG0yyJU/16825175d26ad9daadb39bb1a49bb9bd/HourofAI_Project_JavaScript1.png",
  },
  {
    id: 87,
    title: "Learning with AI",
    provider: "JoySchooler",
    description: "This series explores the science of how we learn and provides a practical framework for using AI not as a shortcut, but as a tool to deepen understanding through productive struggle and guided questioning.",
    gradeRange: "6-12",
    playUrl: "https://joyschooler.com/course/f019036e-cd21-4b7d-8c6a-4c6c7027dd41?event=ai",
    teacherUrl: "https://docs.google.com/document/d/1CxUcW43eJEwIkFPKpcDJVPprCUUtnwSVUp1vG_VTtNQ/edit?usp=sharing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/xyM3oUXh3auu431IVZh1J/05e5551a03cc2c37082ba952c23a71c2/learning_with_AI-cover.png",
  },
  {
    id: 88,
    title: "Machine Learning Magic",
    provider: "BirdBrain Technologies",
    description: "Create a machine learning model that makes a wand interactive using the micro:bit, MakeCode, and CreateAI! Students learn the importance of data collection, data analysis, data quality and how data impacts the accuracy of the model.",
    gradeRange: "6-10",
    playUrl: "https://docs.google.com/presentation/d/19MiMczgtpfNuezjNFwlGKSizK6Nkt4TYWT0G8e3YpPQ/view",
    teacherUrl: "https://docs.google.com/document/d/1WSUVRUShQ-GkyvT8wigY9-_4BrHjO_ItSEva8G_6d30/view",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/7MmN7Gd6whWkj7ZgTmSUND/5550d6f42cdb8dff752fce9834cb11ab/BirdBrain_Hour_of_AI_Graphic.png",
  },
  {
    id: 89,
    title: "Machine Learning: What is a Blorg?",
    provider: "CodeHop",
    description: "Students act like AI to recognize 'Blorgs' by finding patterns in data, then design their own alien species. They will learn how machine learning works and explore how computers use data to make decisions.",
    gradeRange: "K-5",
    playUrl: "https://codehs.com/curriculum/elementary/sample/hour_of_ai_blorg",
    teacherUrl: "http://codehs.com/hourofai/blorg/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/TPLT4THrJsf4cRe8LUt21/353ff05f8dd434e305af8ef126ca1c8d/Machine_Learning_-_What_is_a_Blorg_480x360.png",
  },
  {
    id: 90,
    title: "MoveSense AI: Training Movements with micro:bit CreateAI",
    provider: "NBCEDI",
    description: "This activity involves using micro:bit CreateAI to train a machine learning model to recognize specific movements when engaged in physical activity. Learners develop a prototype SmartCoach to help develop technique and accuracy.",
    gradeRange: "6-10",
    playUrl: "https://centresofexcellencenb.ca/digitalinnovation/?learning_activity=movesenseai",
    teacherUrl: null,
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/4L8iUgMsbQKcvWzXYrTzyp/8937eb61fb6c32d10502c808cd1ec3e2/MoveSense-CreateAI-.jpg",
  },
  {
    id: 91,
    title: "Patterns in Nature, Patterns in AI",
    provider: "Indigitize",
    description: "Students discover the role of pattern recognition in human learning and AI. Through a nature walk and machine learning activity, they will learn how AI systems identify patterns in data and recognize why human insight is essential when working with AI.",
    gradeRange: "3-8",
    playUrl: "https://www.indigitize.org/hourofai",
    teacherUrl: "https://docs.google.com/document/d/16T-2_Wq-sb_RU_pqD0mVS-cP7Yei1cV9MYhRjvX6kys/edit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5kTRWhkvNJEsKZHvC6LWOx/57205dc4ee42796cc66f8bb40df97fc6/patternsinnaturepatternsinai.png",
  },
  {
    id: 92,
    title: "Patterns Not Memory: How LLMs Work",
    provider: "Ozobot",
    description: "Students use skip counting as a way to identify patterns and make predictions. Then, they program Ozobot to complete a pattern to understand how LLMs work.",
    gradeRange: "K-5",
    playUrl: "https://classroom.ozobot.com/",
    teacherUrl: null,
    thumbnailUrl: "",
  },
  {
    id: 93,
    title: "Prompt Power: Getting the Best from AI",
    provider: "CodeHS",
    description: "Students learn how to craft effective prompts for generative AI tools. Through hands-on practice and reflection, they explore how phrasing influences AI outputs and how to refine prompts to get more accurate, creative, and reliable results.",
    gradeRange: "6-12",
    playUrl: "http://codehs.com/hourofai/promptpower",
    teacherUrl: "http://codehs.com/hourofai/promptpower/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/62hGhqLh6XRTElXi0ok8po/9e136627c8af150e7789fdc433b79471/Prompt_Engineering_480x360.png",
  },
  {
    id: 94,
    title: "Supercharge Your Ideas With Your AI Critique Squad",
    provider: "NAF",
    description: "Create your mobile business idea, then assemble your AI Critique Squad! Use your squad's feedback to supercharge your ideas while exploring how AI works.",
    gradeRange: "9-12",
    playUrl: "https://ash.naf.org/public/learning/project/hour-of-ai-2025",
    teacherUrl: "https://docs.google.com/document/d/1xHYbmHPg35VohJ96j7pDUVX4ThCly1senL2nJIlsuYk/edit?usp=sharing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/a006GJ9Lr890DkvfaJdt5/400c2e49d6ee6fa6f65534d54865c529/Hour_of_AI_Cover_Image.png",
  },
  {
    id: 95,
    title: "The Bias Detective",
    provider: "Montana Digital Academy",
    description: "Students build a biased image classifier using Teachable Machine and skewed data. They test it to find a failure point (the 'Bias Breakthrough') and reflect on real-world implications of biased AI systems.",
    gradeRange: "6-12",
    playUrl: "https://docs.google.com/presentation/d/1cCiEo5no2V8NdSHLn7vjhDR3RALt1pihD_zLutuc-5s/edit",
    teacherUrl: "https://docs.google.com/document/d/1NHiJp131Uf-n9bj4M86cuCZkQW0bZGCeom2j5FucSKw/edit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/6V5ByOC1ZkgxSiuKhgKX0H/dcdf95ed3419170f237017ef28d5cb23/Bias-Detective-Cover-Image.jpg",
  },
  {
    id: 96,
    title: "The Feynman Technique / The Teaching Test",
    provider: "JoySchooler",
    description: "Discover how explaining ideas in your own simple words can reveal what you know, show where you're stuck, and help you learn more deeply.",
    gradeRange: "6-12",
    playUrl: "https://joyschooler.com/course/learning-science/lesson/feynman",
    teacherUrl: "https://docs.google.com/document/d/1u2ISg4JmzHEjTsTNXyYJY3zTuuiN1OD5-9tffK733ow/edit?usp=sharing",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5pKPQstlftqg5Nus8QqOn4/49aa485cda7c3635fae931e973cdab86/feynman-cover.png",
  },
  {
    id: 97,
    title: "What Is AI (3-5)",
    provider: "Seesaw Learning",
    description: "Through a comic, interactive activities, and reflection questions, students learn how AI works, when to use AI tools, and how to use it safely and responsibly.",
    gradeRange: "3-5",
    playUrl: "https://app.seesaw.me/library/my_library/lesson/prompt.fd7812c5-d0d6-49ad-aee7-455a08ac760e",
    teacherUrl: "https://docs.google.com/document/d/1OYBdQd2zHYqjMc8I2LQMdkxGhOCcVZt43RSXZj8uQqo/edit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/37pmxgz1wZYkzQ0qGWW4NO/12b4e00afa18f08f6a4fb341d79588dc/What_Is_AI__3-5.png",
  },
  {
    id: 98,
    title: "What Is AI (K-2)",
    provider: "Seesaw Learning",
    description: "Through a comic, interactive activities, and reflection questions, students learn how AI works, when to use AI tools, and how to use it safely and responsibly.",
    gradeRange: "K-2",
    playUrl: "https://app.seesaw.me/library/my_library/lesson/prompt.b36701d7-1344-4ebf-a959-f0cbe9b50d13",
    teacherUrl: "https://docs.google.com/document/d/1OYBdQd2zHYqjMc8I2LQMdkxGhOCcVZt43RSXZj8uQqo/edit",
    thumbnailUrl: "",
  },
  {
    id: 99,
    title: "AI Unplugged",
    provider: "Digital Schoolhouse",
    description: "Through several unplugged activities, students learn how generative AI works by generating content based on a user's prompt and how it learns by analyzing training data.",
    gradeRange: "6-12",
    playUrl: "https://www.digitalschoolhouse.org.uk/Hour-of-AI/ai-unplugged",
    teacherUrl: "https://drive.google.com/file/d/1WdRUXzz-J21TP6QwEJPprNvhLEAW9EzR/view?usp=drive_link",
    thumbnailUrl: "",
  },
  {
    id: 100,
    title: "How Machines Learn",
    provider: "CodeHop",
    description: "Students explore how humans and computers learn, compare supervised, unsupervised, and reinforcement learning, and build decision trees to classify objects, gaining hands-on experience with AI concepts and data patterns.",
    gradeRange: "K-5",
    playUrl: "https://codehs.com/curriculum/elementary/sample/hour_of_ai_how_machines_learn",
    teacherUrl: "http://codehs.com/hourofai/howmachineslearn/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5G27RiklzqnLFeauInfoWs/38bb50a7253a431107845fe3e2ef30dc/How_Machines_Learn_480x360.png",
  },
  {
    id: 101,
    title: "Imagine the Future",
    provider: "Indigitize",
    description: "In this unplugged lesson, students explore how AI works and how it can be designed for good. They simulate how AI learns through an AI training example, brainstorm community-focused solutions, and design their own AI innovation.",
    gradeRange: "K-5",
    playUrl: "https://www.indigitize.org/hourofai",
    teacherUrl: "https://docs.google.com/document/d/15t41gs8TaqZeGAe0M5z-P5E-8P23Cn2ulOe_KTeaLXI/edit",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2ddnt8zK6xm4JBIrvpEMIy/c2a6ec2cb17449b517661b88236c5c41/Imagine_the_Future.png",
  },
  {
    id: 102,
    title: "My Paper Language Model",
    provider: "Aarhus University",
    description: "Students create a fun, visual, paper sentence generator: by writing 4-word sentences, splitting them into word piles, and then recombining the words to generate new sentences. They reflect on patterns, probabilities, and what makes a good generation model.",
    gradeRange: "6-12",
    playUrl: "https://maskinrummet.github.io/#/en/hour-of-ai",
    teacherUrl: "https://drive.google.com/file/d/1ZbCkHwwOQB0Q8c7gmIItw-JhpbcRMqNb/view",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/2nORWDpUtBlpQsfo0JDrzD/977e402e0c54b014a4b47cf177756107/My_Paper_Language_Model.jpg",
  },
  {
    id: 103,
    title: "NASA Space Detectives: Exploring the Universe with AI",
    provider: "NASA / Smithsonian",
    description: "In NASA Space Detective, learners become cosmic sleuths using AI concepts to classify celestial objects from Chandra and other telescope data. Sort stars vs galaxies, explore how algorithms 'learn,' and discover how AI accelerates astronomical research.",
    gradeRange: "6-12",
    playUrl: "https://chandra.si.edu/ai/detect/",
    teacherUrl: null,
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/xOjpA1yE4iLcK0BOlq1Z4/9c107fee012c138d6d76ad2df14805a3/Exploring_the_Universe_with_AI.jpg",
  },
  {
    id: 104,
    title: "Sorting with Decision Trees",
    provider: "CodeHop",
    description: "Students learn how computers make choices by using a handout to create simple decision trees. They sort pictures into yes/no branches, reflect on how they acted like a computer, and see how rules help AI recognize patterns.",
    gradeRange: "K-5",
    playUrl: "https://codehs.com/curriculum/elementary/sample/hour_of_ai_decision_trees",
    teacherUrl: "http://codehs.com/hourofai/decisiontrees/guide",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5bIYam8aj6xqZqXybiALIU/15388156474284bffabe857209b29b36/Sorting_with_Decision_Trees_480x360.png",
  },
  {
    id: 105,
    title: "Tech Ethics and Impacts Card Game",
    provider: "Amber Sparks Education",
    description: "In the Tech Ethics and Impacts Card Game, students unplug to design their dream robot and then present to their peers. Once they have submitted, students will compete against each other as they present scenarios.",
    gradeRange: "6-12",
    playUrl: "https://ai4ga.org/tech-impacts-game/",
    teacherUrl: "https://docs.google.com/presentation/d/1vpI5j5BGjnlRUgfeIJg5daMVp1hwVwf4d4gIn7CNRqs/edit",
    thumbnailUrl: "",
  },
  {
    id: 106,
    title: "The Trial of the Robot: A Theatrical Activity on AI",
    provider: "Binary Logic",
    description: "Students stage a mock trial of a robot that did their homework. Through role-play as judges, lawyers, and the robot, they debate who's responsible and learn AI is a human-made tool.",
    gradeRange: "K-5",
    playUrl: "https://binarylogic.net/hourofai-activity-for-elementary-students/",
    teacherUrl: "https://drive.google.com/file/d/1mdMWgXSqPB24C6BPGRC1cJv4Xh1cpXoc/view",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/5xxHR8ltBcvs2NJHOhW3Sh/99ff53ab2433ca50ee8a7baf8e789487/BL_HofAI_ES.jpg",
  },
  {
    id: 107,
    title: "Thinking About Thinking",
    provider: "Woz ED",
    description: "Students will explore AI by first understanding their own thinking. AI involves devices that perceive and act to achieve goals. Students will analyze their thought processes and see that there are many ways to solve a problem.",
    gradeRange: "K-5",
    playUrl: "https://wozed.link/HoAI_LowerGuide",
    teacherUrl: "https://ntimages.weebly.com/ressources.html",
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/pWEIupXthRS3Ff3K4xQbO/45ac90933216b6f80ddedb07dd88f409/AI_L2_M_HoAI_Image.jpeg",
  },
  {
    id: 108,
    title: "Tokenizer Visualizer",
    provider: "Myai101",
    description: "An interactive playground to explore how AI breaks down language into tokens — the building blocks of its understanding. Visualize how text becomes numbers and listen & learn the process of how models like GPT read & process words.",
    gradeRange: "9-12",
    playUrl: "https://myai101.com/hourofai/tokenizer",
    teacherUrl: null,
    thumbnailUrl: "https://contentful-images.code.org/27jkibac934d/6YYDKiaS08zIN3tWjKoowa/e4d2f1f70875a21cbbdf8a794a8b4395/Tokenizer_cover_image__1_.png",
  },
];
